import { client } from '@trello/graphql';
// eslint-disable-next-line no-restricted-imports
import type { Action } from '@trello/redux';
// eslint-disable-next-line no-restricted-imports
import { actionCreator } from '@trello/redux';

// eslint-disable-next-line no-restricted-imports
import type { BoardResponse } from 'app/gamma/src/types/responses';
// eslint-disable-next-line no-restricted-imports
import type { StandardThunkAction, Dispatch } from 'app/gamma/src/types';
// eslint-disable-next-line no-restricted-imports
import type { State } from 'app/gamma/src/modules/types';
import type {
  LoadBoardQuery,
  LoadBoardQueryVariables,
} from './LoadBoardQuery.generated';
import { LoadBoardDocument } from './LoadBoardQuery.generated';
import { featureFlagClient } from '@trello/feature-flag-client';
import { cacheFactory } from '@trello/quickload';

// Action types
export const LOAD_BOARD_REQUEST = Symbol('loaders/LOAD_BOARD_REQUEST');
export const LOAD_BOARD_SUCCESS = Symbol('loaders/LOAD_BOARD_SUCCESS');

export type LoadBoardRequestAction = Action<typeof LOAD_BOARD_REQUEST, string>;
export type LoadBoardSuccessAction = Action<
  typeof LOAD_BOARD_SUCCESS,
  BoardResponse
>;

// Action creators
const loadBoardRequest = actionCreator<LoadBoardRequestAction>(
  LOAD_BOARD_REQUEST,
);
export const loadBoardSuccess = actionCreator<LoadBoardSuccessAction>(
  LOAD_BOARD_SUCCESS,
);

export const loadBoard = (boardIdentifier: string): StandardThunkAction => {
  return async (dispatch: Dispatch, getState: () => State) => {
    dispatch(loadBoardRequest(boardIdentifier));
    await cacheFactory.waitForQueryHydratedTo('CurrentBoardFull', 'Apollo');
    const { data, error } = await client.query<
      LoadBoardQuery,
      LoadBoardQueryVariables
    >({
      query: LoadBoardDocument,
      variables: {
        id: boardIdentifier,
      },
      // eslint-disable-next-line @trello/disallow-fetch-policies
      fetchPolicy: featureFlagClient.get('fep.load-board-from-apollo', false)
        ? 'cache-first'
        : 'network-only',
      context: {
        operationName: 'LoadBoard',
        document: LoadBoardDocument,
      },
    });
    const board = data.board;
    if (error || !board) {
      return;
    }
    // TODO: Subscribe to the board socket updates

    dispatch(loadBoardSuccess(board));
  };
};
